// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2foAE","rootNoMargin":"styles_rootNoMargin__2rWso"};